<template>
  <div class="sorting-list">
    <label class="form__label">
      Sorting configs
    </label>
    <div class="form__row">
      <FilterInput title="Filter sorting configs"
                   :filterList="sortings"
                   v-on:filter="onFilterSortings"
      ></FilterInput>
    </div>

    <Loader v-if="isLoading"></Loader>

    <div class="sorting-list-wrap" v-if="filteredSortings.length && !isLoading">
      <ul class="selectable-list">
        <li class="selectable-list__item"
            v-for="(sorting, i) in filteredSortings"
            :key="sorting + i"
            :class="{'active': isSortingActive(sorting)}"
            @click="chooseSorting(sorting)"
        >
          {{sorting}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'
  import FilterInput from '../../FilterInput/FilterInput.vue'

  export default {
    name: 'SortingList',
    components: {Loader, FilterInput},
    props: ['chosenSortingName'],
    data () {
      return {
        sortings: [],
        filteredSortings: [], // used to show sortings
        isLoading: false
      }
    },
    created: function () {
      this.getSortings()
    },
    methods: {
      isSortingActive: function (sorting) {
        return this.chosenSortingName && sorting === this.chosenSortingName
      },
      chooseSorting: function (sorting) {
        if (!this.isSortingActive(sorting)) {
          this.$emit('onSelectSorting', sorting)
        }
      },
      onFilterSortings: function (sortings) {
        this.filteredSortings = sortings
      },
      getSortings: function () {
        this.isLoading = true

        return this.$http.get(`${config.apiUrl}/sorting/list`)
          .then(response => {
            let sortings = response.body.map(item => item.sortingName)
            this.sortings = sortings
            this.filteredSortings = sortings
          }, error => {
            console.log(error)
          })
          .then(() => {
            this.isLoading = false
          })
      }
    }
  }
</script>
